<template>
  <Teleport to="body" v-if="visible">
    <div class="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 z-50 flex justify-center items-start pt-0" @click="emit('update:visible', false)">
      <div class="bg-blue-900 w-screen rounded-b-3xl p-5 shadow-2xl" @click.stop>
        <!-- 关闭按钮 -->
        <div class="flex justify-end mb-5">
          <button @click="emit('update:visible', false)" class="bg-transparent border-none p-1 cursor-pointer">
            <img src="@/assets/close.png" alt="Close" class="w-4 h-4 block" />
          </button>
        </div>
        
        <!-- 头部 -->
        <div class="mb-6">
          <h2 class="text-white text-xl font-semibold text-left">{{ languageTexts.selectLanguage }}</h2>
        </div>

        <!-- 语言网格 -->
        <div class="px-1 pb-6">
          <div class="grid grid-cols-3 gap-4">
            <div
              v-for="lang in languages"
              :key="lang.code"
              @click="handleClick(lang)"
              class="flex flex-col items-center gap-2 p-3 rounded-lg transition-colors cursor-pointer relative"
              :class="[
                lang.enabled ? 'hover:bg-white hover:bg-opacity-10' : 'opacity-50 cursor-not-allowed',
                locale === lang.code ? 'bg-white bg-opacity-20 border-2 border-white border-opacity-60' : ''
              ]"
            >
              <!-- 选中标记 - 放在国旗上方 -->
              <div class="h-5 flex items-center justify-center">
                <span
                  v-if="locale === lang.code"
                  class="text-white text-base font-bold"
                >
                  ✓
                </span>
              </div>
              <img
                :src="lang.flag"
                :alt="`${lang.name} Flag`"
                class="w-8 h-6 rounded-sm object-cover"
                :class="{ 'grayscale': !lang.enabled }"
              />
              <span
                class="text-white text-sm text-center leading-tight"
                :class="{
                  'text-gray-400': !lang.enabled,
                  'font-bold': locale === lang.code
                }"
              >
                {{ lang.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { defineProps, defineEmits, computed } from "vue";
import { useI18n } from 'vue-i18n'
import { languages } from '@/utils/languages'

const { locale, messages } = useI18n()

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  languages: {
    type: Array,
    required: true,
    default: () => []
  }
});

const emit = defineEmits(["update:visible", "select-language"]);

// 获取语言选择文案
const languageTexts = computed(() => {
  return messages.value[locale.value]?.language || {
    selectLanguage: 'Choose language'
  };
});

function handleClick(lang) {
  if (!lang.enabled) {
    alert(`语言 ${lang.name} 暂不支持`);
    return;
  }
  emit("select-language", lang);
  emit("update:visible", false);
}
</script>
